import styled from "styled-components/macro";

export const TableRowStyled = styled.tr<{ canSelect?: boolean }>`
  cursor: ${(props) => (props.canSelect ? "pointer" : "default")};
`;
